import { observer } from 'mobx-react-lite'
import { Link } from 'react-router'
import { Box, Icon, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useReviewViewContext } from 'pages/reviews/context'
import { getPoweredBySalesmsgLink } from 'pages/reviews/lib/getPoweredBySalesmsgLink'
import styles from './styles.module.scss'

export const PreviewFooter = observer(() => {
  const { bgColor } = useReviewViewContext()
  const { organizationStore } = useEntitiesContext()

  return (
    <Box
      className={styles.footer}
      sx={{ background: `linear-gradient(180deg, transparent 0%, ${bgColor} 75%)` }}
    >
      <Link
        to={getPoweredBySalesmsgLink(organizationStore.id)}
        className={styles.footerLink}
        target={'_blank'}
      >
        <Icon icon='logoOld' color='#1D95F2' fontSize={14} />
        <Typography ariaLabel={'title'} variant={'body-sm-regular'}>
          Powered by Salesmsg
        </Typography>
      </Link>
    </Box>
  )
})
